import { floorList_template } from '../components/templates/floorList_template';
import { vnModule_knockoutJS } from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class floor_list extends vnModule_knockoutJS{

    protected template: floorList_template;
    protected requestHandler: XMLHttpRequestHandler;

    /**
     * @inheritDoc
     */
    protected getModuleName(): string{

        return 'floor_list';
    }

    /**
     * @inheritDoc
     */
    public buildContent() : Array<Element>{

        let zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle('Floors');

        this.template = new floorList_template('floorList_template', this.viewModel, this)

        return [this.template.build()];
    }

    /**
     * @inheritDoc
     */
    public fillPage(): void{

        this.getListData();
    }

    //
    // Hook.
    // Initiates data refresh.
    public paginationOnPageClick(): void{

        this.getListData();
    }

    /**
     * @inheritDoc
     */
    protected reorderTemplates(): void{

        this.getListData();
    }

    //
    // Fetches the list data.
    public getListData(): void{

        this.loadingIn(this.template.builtTemplate);

        let subViewModel = this.template.getViewModelForRequest();

        let params: Array<Array<string>> = [];
        params.push(['data', ko.toJSON(subViewModel)] );

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let url     = '';   

        if(idBrand){

            url = `/api/brand/${idBrand}/floors/get/`;
        }
        else{

            url = `/api/floors/get/`;
        }

        this.requestHandler = new XMLHttpRequestHandler(url, params, this);
        this.requestHandler.onReadyStateFunction = this.onDataRequestReturn;
        this.requestHandler.execute();
    }

    //
    // Returns handler for data request.
    protected onDataRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateList(responseParsed);
                obj.loadingOut(obj.template.builtTemplate);
            });
        }
    }

    //
    // Deletes the requested resource.
    protected delete(id): void{

        this.loadingIn(this.template.builtTemplate);

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let url     = '';

        if(idBrand){

            url = `/api/brand/${idBrand}/floors/delete/${id}`;
        }
        else{

            url = `/api/floors/delete/${id}`;
        }

        this.requestHandler                      = new XMLHttpRequestHandler(url, [], this);
        this.requestHandler.mode                 = XMLHttpRequestHandler_requestType.POST;
        this.requestHandler.onReadyStateFunction = this.onDeleteRequestReturn;
        this.requestHandler.execute();
    }

    //
    // Returns handler for delete request.
    protected onDeleteRequestReturn(req, obj): Function{

        return function(){

            obj.loadingOut(obj.template.builtTemplate);

            obj.manageResponse(req, obj, function(){

                obj.getListData();
            });
        }
    }

    //
    // Update the module list using the objects list.
    protected updateList(responseParsed: any): void{

        this.loadingIn(this.template.builtTemplate);
        this.template.setListData(responseParsed);
    }

    //
    // Hook.
    // Redirects to create page.
    protected add(): void{

        let idBrand = this.getVnAppZone().app.params.idBrand;

        if(idBrand){

            page(`/brand/${idBrand}/floors/add`);
        }
        else{
            
            page(`/floors/add`);
        }
    }

    //
    // Hook.
    // Redirects to create page.
    protected edit(id): void{

        let idBrand = this.getVnAppZone().app.params.idBrand;

        if(idBrand){

            page(`/brand/${idBrand}/floors/edit/${id}`);
        }
        else{
            
            page(`/floors/edit/${id}`);
        }
    }

    /** @inheritDoc */
    public confirmationModalOnClickConfirm(context, data): void{

        this.delete(data);
    }

    /** @inheritDoc */
    public confirmationModalOnClickClose(context, data): void{

    }

    //
    // Hook.
    // Returns brand ID.
    public getBrandId(): string{

        return this.getVnAppZone().app.params.idBrand;
    }

    //
    // Hook.
    // Redirects to create page.
    public goTo(idBrand): void{

        if(idBrand){

            page(`/brand/${idBrand}/floors`);
        }
        else{
            
            page(`/floors`);
        }
    }
}